import { makeStyles } from '@material-ui/core/styles';

const useCardStyles = makeStyles(theme => ({
    description: {
        margin: '10px 0',
            display: 'block',
            fontSize: '0.9rem'
    },
    card: {
        display: "flex",
            flexDirection: "column",
            height: '100%',
            textAlign: 'left',
            justifyContent: 'space-between',

            '& .MuiCardHeader-root': {
            paddingBottom: 0,
        },
        '& .MuiCardHeader-title': {
            fontWeight: 500,
        },
        '& .MuiCardContent-root': {
            wordBreak: 'break-all',
        },
        '& .MuiCardActions-root': {
            justifyContent: 'center',
                marginBottom: '1rem',
                borderRadius: '50px'
        }
    },
    minHeight: {
        height: '300px',
            overflow: 'scroll'
    },
    cardContent: {
        padding: 0
    },
    inclusive: {
        backgroundColor: theme.palette.secondary.main,
    },
    contact: {
        backgroundColor: theme.palette.primary.main,
    },
    exclusive: {
        backgroundColor: '#e61e19',
    },
    filterGrid: {
        border: '1px solid #000',
    },
    paper: {
        padding: '1rem'
    },
    expansionPanel: {
        boxShadow: 'none',
            '& .MuiExpansionPanelSummary-root': {
            padding: 0,
                '& .MuiExpansionPanelSummary-content.Mui-expanded': {
                marginBottom: 0
            }
        },
        '& .MuiExpansionPanelSummary-content': {
            flexDirection: 'column'
        },
        '& .MuiExpansionPanelDetails-root': {
            padding: 0,
                '& .MuiListItem-root': {
                padding: '0.5rem 0'
            }
        }
    },
    leadSourcePaper: {
        height: '600px',
        overflow: 'scroll'
    },
    leadSourceRows: {
        minHeight: '25px',
            padding: '10px',
            border: '1px solid',
            borderTop: 'none'
    }
}));

export default useCardStyles;
